import { render } from "./Streams.vue?vue&type=template&id=445a9072"
import script from "./Streams.vue?vue&type=script&lang=js"
export * from "./Streams.vue?vue&type=script&lang=js"

import "./Streams.vue?vue&type=style&index=0&id=445a9072&lang=css"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__